import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl, FormattedMessage } from 'react-intl'
import cloneDeep from 'lodash/cloneDeep'
import Modal from '@vtex/styleguide/lib/Modal'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import MessageLoader from '@/checkout-instore-legacy/components/Commons/MessageLoader'
import { CHECKOUT_GROUPS } from '@/checkout-instore-legacy/constants/CheckoutConstants'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'
import CouponContainer from '../Commons/Coupon/CouponContainer'
import PaymentsPaidContainer from '@/checkout-instore-legacy/payment/containers/PaymentsPaidContainer'
import PaymentSelectionContainer from '@/checkout-instore-legacy/payment/containers/PaymentSelectionContainer'
import SummaryView from '@/checkout-instore-legacy/components/Commons/Summary/containers/SummaryViewContainer'
import {
  endPaymentEvent,
  logClickEvent,
} from '@/checkout-instore-legacy/utils/EventHelper'
import { getDocumentType } from '@/checkout-instore-legacy/utils/orderFormUtils'
import FooterButton from '@/checkout-instore-legacy/components/Commons/Elements/FooterButton'
import pgUtils from '@/checkout-instore-legacy/utils/PromiseGroupUtils'
import * as PaymentUtils from '@/checkout-instore-legacy/utils/PaymentUtils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import { findVtexGiftCard } from '@/checkout-instore-legacy/returnExchange/utils'
import AddPaymentButton from './AddPaymentButton'
import PaymentToolbar from './PaymentToolbar'
import DocumentForReceiptContainer from './PaymentSelection/DocumentForReceipt/DocumentForReceiptContainer'
import SocialShareContainer from '@/checkout-instore-legacy/share/containers/SocialShareContainer'
import GiftCardCode from './PaymentSelection/GiftCardsList/GiftCardCode'
import NoPaymentsAvailableNotification from './NoPaymentsAvailableNotification'
import {
  documentMaskForType,
  documentPlaceholderForType,
} from '@/checkout-instore-legacy/utils/DocumentUtils'
import { AmplitudeSidebarLabels } from '@/checkout-instore-legacy/constants/AmplitudeConstants'
import { sendMetric } from '@/checkout-instore-legacy/VtexLakeHouse'
import {
  MetricAction,
  MetricShowcase,
} from '@/checkout-instore-legacy/VtexLakeHouse/typings'

class Payment extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDocumentModal: false,
      showAddPaymentModal: false,
      showShare: false,
      showCoupon: false,
      showGiftCard: false,
      newGiftCardRedemptionCode: '',
      selectedGiftCardProvider: null,
      isGiftCardLoading: false,
    }
  }

  componentDidMount() {
    this.props.clearCancelGivenOrder()

    const orderForm = this.props.order.orderForm

    this.redirectWhenMissingOrderFormProperty(orderForm)

    if (!orderForm) {
      this.props.loadInStoreOrderForm(this.props.vendor)
    }

    this.props.getGiftCardProviders()
    this.checkForGiftCardPreSelection()
    this.props.preventMixedAddressId()
    this.props.refreshPermissionsPerSeller()
  }

  componentDidUpdate(prevProps) {
    if (this.props.order !== prevProps.order) {
      const orderState = this.props.order
      const orderForm = orderState.orderForm
      const redirectRoute = this.getRedirectRoute(orderForm)

      if (redirectRoute) {
        this.props.router.push(redirectRoute)
      }

      this.setState({
        showOrderCancellationLoader: orderState.cancellationStatus.isCancelling,
      })
    }

    this.checkForGiftCardPreSelection()
  }

  checkForGiftCardPreSelection() {
    const orderForm = this.props.order.orderForm
    const { shouldPreSelectGiftCard } = this.props
    if (shouldPreSelectGiftCard) {
      const {
        paymentData: { giftCards },
      } = orderForm
      const vtexGiftCard = findVtexGiftCard(giftCards)

      if (vtexGiftCard) {
        setTimeout(() => this.props.addGiftCard(vtexGiftCard), 1000)
        this.props.setHasPreSelected()
      }
    }
  }

  redirectWhenMissingOrderFormProperty(orderForm) {
    const redirectRoute = this.getRedirectRoute(orderForm)

    if (redirectRoute) {
      this.props.router.push(redirectRoute)
    }

    return redirectRoute
  }

  getRedirectRoute(orderForm) {
    return (
      this.checkClientProfileRedirect(orderForm) ||
      this.checkItemsRedirect(orderForm) ||
      this.checkPaymentDataRedirect(orderForm)
    )
  }

  checkClientProfileRedirect = (orderForm) => {
    return orderForm && !orderForm.clientProfileData ? '/' : null
  }

  checkItemsRedirect = (orderForm) => {
    return orderForm && orderForm.items.length === 0 ? '/cart' : null
  }

  checkPaymentDataRedirect = (orderForm) => {
    return orderForm &&
      (!orderForm.paymentData ||
        !orderForm.paymentData.paymentSystems ||
        orderForm.paymentData.paymentSystems.length === 0)
      ? '/cart'
      : null
  }

  getDocumentOnReceipt() {
    const orderForm = this.props.order.orderForm

    const profileDocument =
      orderForm && orderForm.clientProfileData
        ? orderForm.clientProfileData.document
        : null
    const receiptDocument =
      orderForm && orderForm.marketingData
        ? orderForm.marketingData.utmCampaign
        : null

    return receiptDocument || profileDocument
  }

  handleSubmit = () => {
    const { orderForm, transaction } = this.props.order

    sendMetric({
      action: MetricAction.PaymentsStart,
      showcase: MetricShowcase.Payments,
      payment_methods: orderForm.paymentData.payments,
    })
    endPaymentEvent(orderForm)
    this.props.router.push('/placeorder')
    this.props.startOrder(transaction)
  }

  handleShowDocumentModal = () => {
    this.setState({ showDocumentModal: true })
  }

  handleShowAddPaymentModal = () => {
    this.setState({ showAddPaymentModal: true })
  }

  handleHideAddPaymentModal = () => {
    this.setState({ showAddPaymentModal: false })
  }

  handleHideDocumentModal = () => {
    this.setState({ showDocumentModal: false })
  }

  handleOpenCouponModal = () => {
    logClickEvent('open-coupon-modal', 'Sale')

    this.setState({ showCoupon: true })
  }

  handleCloseCouponModal = () => {
    logClickEvent('close-coupon-modal', 'Sale')

    this.setState({ showCoupon: false })
  }

  handleOpenShare = () => {
    logClickEvent('open-social-share', 'Sale')

    this.setState({ showShare: true })
  }

  handleCloseShare = () => {
    logClickEvent('close-social-share', 'Sale')

    this.setState({ showShare: false })
  }

  handleChangeNewGiftCardCode = (redemptionCode) => {
    this.setState({
      newGiftCardRedemptionCode: redemptionCode,
    })
  }

  handleChangeGiftCardProvider = (newGiftCardProvider) => {
    this.setState({
      selectedGiftCardProvider: newGiftCardProvider,
    })
  }

  handleOpenGiftCardCodeModal = () => {
    logClickEvent('open-gift-card-modal', 'Sale')

    this.setState({ showGiftCard: true })
  }

  handleCloseGiftCardCodeModal = () => {
    logClickEvent('close-gift-card-modal', 'Sale')

    this.setState({
      showGiftCard: false,
      newGiftCardRedemptionCode: '',
      isGiftCardLoading: false,
    })
  }

  handleSaveNewGiftCardCode = (redemptionCode, selectedGiftCardProvider) => {
    logClickEvent('submit-gift-card-button', 'Sale')

    this.setState({ isGiftCardLoading: true })

    const newGiftCard = this.props.addNewGiftCardWithRedemptionCode(
      redemptionCode,
      selectedGiftCardProvider
    )

    this.props.addGiftCard(newGiftCard)

    pgUtils
      .waitFor(CHECKOUT_GROUPS.setPayments)
      .then(() => {
        this.handleCloseGiftCardCodeModal()
      })
      .catch(() => {
        this.setState({ isGiftCardLoading: false })
      })
  }

  renderFooterButton = () => {
    const {
      order,
      orderGroupId,
      shouldRefundPaymentsPaid,
      showRefundPaymentsPaidDialog,
      isOnline,
    } = this.props
    const orderForm = order.orderForm
    const giftCards = order.localPaymentData.giftCards
    const payments = order.localPaymentData.payments

    const isButtonDisabled = !PaymentUtils.shouldShowSubmitButton(
      orderForm.value,
      payments,
      giftCards,
      orderGroupId,
      shouldRefundPaymentsPaid,
      isOnline
    )

    return (
      <FooterButton
        id="place-order"
        onClick={this.handleSubmit}
        onClickOnDisabled={() =>
          shouldRefundPaymentsPaid && showRefundPaymentsPaidDialog()
        }
        kind="success"
        disabled={isButtonDisabled}
        className="absolute-l bottom-0-l right-0-l w-25-l lh-copy-l"
      >
        {shouldRefundPaymentsPaid ? (
          <FormattedMessage id="refundPaymentsPaidToProceed" />
        ) : (
          <FormattedMessage id="placeOrderLabel" />
        )}
      </FooterButton>
    )
  }

  get messageId() {
    const {
      order: { cancellationStatus },
    } = this.props

    return cancellationStatus.messageId
  }

  render() {
    const {
      showShare,
      showCoupon,
      showGiftCard,
      newGiftCardRedemptionCode,
      selectedGiftCardProvider,
      isGiftCardLoading,
    } = this.state
    const { intl, order, splitPayments, totalsPerSeller } = this.props
    const giftCardProviders = order.giftCardProviders
    const orderForm = order.orderForm
    const payments = cloneDeep(order.localPaymentData.payments)
    const giftCards = cloneDeep(order.localPaymentData.giftCards)
    const document = this.getDocumentOnReceipt()
    const documentType =
      orderForm.clientProfileData.documentType ?? getDocumentType(orderForm)
    const loading = order.loading || !orderForm
    const { payments: paymentsFilters } = getInstoreConfig()

    if (!orderForm) {
      return <Loader loading />
    }

    const paymentSystems = PaymentUtils.filterPaymentSystemsByConfig(
      orderForm.paymentData.paymentSystems,
      paymentsFilters
    )

    const availablePayments = PaymentUtils.getAvailablePayments(
      payments,
      paymentSystems
    )

    return (
      <Fragment>
        {this.props.order.cancellationStatus.isCancelling ? (
          <MessageLoader messageId={this.messageId} />
        ) : null}
        <SummaryView renderFooterButton={this.renderFooterButton}>
          <div className="flex-auto flex flex-column">
            <div className="flex-none">
              <PaymentToolbar
                hasCoupon={
                  !!(orderForm.marketingData && orderForm.marketingData.coupon)
                }
                document={document}
                documentType={documentType}
                onClickDocument={this.handleShowDocumentModal}
                onClickCoupon={this.handleOpenCouponModal}
                onClickGiftCard={this.handleOpenGiftCardCodeModal}
                onShareClick={this.handleOpenShare}
              />
            </div>
            <div className="flex-auto bg-base overflow-auto">
              <NoPaymentsAvailableNotification
                paymentSystems={paymentSystems}
                payments={availablePayments}
                giftCards={giftCards}
              />
              {!splitPayments && (
                <PaymentsPaidContainer showConfirmationModal />
              )}
              <PaymentSelectionContainer
                id="payment-selection"
                value={orderForm.value}
                splitPayments={splitPayments}
                totalsPerSeller={totalsPerSeller}
                paymentSystems={paymentSystems}
                installmentOptions={orderForm.paymentData.installmentOptions}
                payments={availablePayments}
                giftCards={giftCards}
                showAddPaymentModal={this.state.showAddPaymentModal}
                onHideAddPaymentModal={this.handleHideAddPaymentModal}
                intl={intl}
              />
              {!splitPayments && (
                <AddPaymentButton
                  giftCards={giftCards}
                  payments={availablePayments}
                  value={orderForm.value}
                  onClick={this.handleShowAddPaymentModal}
                />
              )}
            </div>
          </div>
        </SummaryView>

        <Modal
          centered
          isOpen={this.state.showDocumentModal}
          onClose={this.handleHideDocumentModal}
        >
          <DocumentForReceiptContainer
            id="document"
            onSubmit={this.handleHideDocumentModal}
            document={document}
            documentType={documentType}
            mask={documentMaskForType({ documentType })}
            placeholder={documentPlaceholderForType({ documentType })}
          />
        </Modal>

        <Modal centered isOpen={showShare} onClose={this.handleCloseShare}>
          <SocialShareContainer orderForm={orderForm} />
        </Modal>

        <Modal
          centered
          isOpen={showCoupon}
          onClose={this.handleCloseCouponModal}
        >
          <CouponContainer
            value={
              orderForm.marketingData && orderForm.marketingData.coupon
                ? orderForm.marketingData.coupon
                : ''
            }
            onClose={this.handleCloseCouponModal}
            isOpen={showCoupon}
            isLoading={loading}
          />
        </Modal>

        <Modal
          centered
          isOpen={showGiftCard}
          onClose={this.handleCloseGiftCardCodeModal}
        >
          <GiftCardCode
            redemptionCode={newGiftCardRedemptionCode}
            giftCardProviders={giftCardProviders}
            selectedGiftCardProvider={selectedGiftCardProvider}
            isGiftCardLoading={isGiftCardLoading}
            onChange={this.handleChangeNewGiftCardCode}
            onChangeProvider={this.handleChangeGiftCardProvider}
            onSubmit={this.handleSaveNewGiftCardCode}
          />
        </Modal>
      </Fragment>
    )
  }
}

Payment.propTypes = {
  router: PropTypes.any,
  intl: intlShape.isRequired,
  order: PropTypes.object.isRequired,
  orderGroupId: PropTypes.string,
  clearCancelGivenOrder: PropTypes.func.isRequired,
  loadInStoreOrderForm: PropTypes.func.isRequired,
  getGiftCardProviders: PropTypes.func.isRequired,
  sendPayments: PropTypes.func.isRequired,
  addNewGiftCardWithRedemptionCode: PropTypes.func.isRequired,
  addGiftCard: PropTypes.func.isRequired,
  vendor: PropTypes.object,
  shouldPreSelectGiftCard: PropTypes.bool,
  setHasPreSelected: PropTypes.func.isRequired,
  preventMixedAddressId: PropTypes.func.isRequired,
  refreshPermissionsPerSeller: PropTypes.func.isRequired,
  splitPayments: PropTypes.bool.isRequired,
  totalsPerSeller: PropTypes.object.isRequired,
  shouldRefundPaymentsPaid: PropTypes.bool,
  showRefundPaymentsPaidDialog: PropTypes.func.isRequired,
  isOnline: PropTypes.bool,
}

Payment.defaultProps = {
  isOnline: true,
}

export default injectIntl(withOrderFormAndVendor(withRouter(Payment)))
